<template>
  <div class="bottom-nav">
    <div
      class="nav-item"
      :class="{ active: $route.path === '/message' }"
      @click="navigateTo('/message')"
    >
      <div class="nav-icon">
        <el-icon><ChatDotRound /></el-icon>
        <span class="nav-badge" v-if="unreadCount > 0">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </div>
      <span class="nav-text">消息</span>
    </div>

    <div
      class="nav-item"
      :class="{ active: $route.path === '/stats' }"
      @click="navigateTo('/stats')"
    >
      <div class="nav-icon">
        <el-icon><TrendCharts /></el-icon>
      </div>
      <span class="nav-text">统计</span>
    </div>

    <div
      class="nav-item center-item"
      :class="{ active: $route.path === '/home' }"
      @click="navigateTo('/home')"
    >
      <div class="nav-icon">
        <el-icon><HomeFilled /></el-icon>
      </div>
      <span class="nav-text">首页</span>
    </div>

    <div
      class="nav-item"
      @click="goToMall"
    >
      <div class="nav-icon">
        <el-icon><Box /></el-icon>
      </div>
      <span class="nav-text">商城</span>
    </div>

    <div
      class="nav-item"
      :class="{ active: $route.path === '/profile' }"
      @click="navigateTo('/profile')"
    >
      <div class="nav-icon">
        <el-icon><User /></el-icon>
      </div>
      <span class="nav-text">我的</span>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { onMounted, computed, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'

import {
  HomeFilled,
  ChatDotRound,
  TrendCharts,
  User,
  Box
} from '@element-plus/icons-vue'

const router = useRouter()
const store = useStore()

let refreshTimer = null

// 从store获取未读消息数量
const unreadCount = computed(() => store.getters['message/unreadCount'])

// 定期刷新未读消息数
const startRefreshTimer = () => {
  refreshTimer = setInterval(() => {
    store.dispatch('message/fetchUnreadCount')
  }, 30000)
}

// 在组件挂载时获取未读消息数量
onMounted(() => {
  // 调用store中的action获取未读消息数量
  store.dispatch('message/fetchUnreadCount')
  startRefreshTimer()
})

// 组件卸载时清理定时器
onUnmounted(() => {
  if (refreshTimer) {
    clearInterval(refreshTimer)
  }
})

const navigateTo = (path) => {
  router.push(path)
}

// 跳转到 CRMEB H5 商城首页（并自动登录）
const goToMall = () => {
  let mallToken = ''
  let spreadUid = ''
  let shareId = ''
  try {
    mallToken = store?.state?.user?.mallToken
      || store?.getters?.['user/mallToken']
      || localStorage.getItem('CRMEB_MALL_TOKEN') || ''
    // 推荐人：从 URL / localStorage / store 三处取
    const urlParams = new URLSearchParams(window.location.search)
    spreadUid = urlParams.get('spread') || localStorage.getItem('pendingSpread') || store?.state?.user?.spreadUid || ''
    shareId = urlParams.get('share_id') || localStorage.getItem('pendingShareId') || ''
  } catch(e) {}

  // 构建跳转 URL：如果跨域（ypt → www.jdat99.com），必须用绝对域名
  const isCrossDomain = !window.location.hostname.includes('jdat99.com')
  const base = isCrossDomain ? 'https://www.jdat99.com' : ''
  let url = base + '/mall/pages/index/index'
  const qs = []
  if (mallToken) qs.push('mall_token=' + encodeURIComponent(mallToken))
  if (spreadUid) qs.push('spread=' + spreadUid)
  if (shareId) qs.push('share_id=' + shareId)
  if (qs.length) url += '?' + qs.join('&')

  console.log('🔗 跳商城 URL:', url.substring(0, 120) + (url.length > 120 ? '...' : ''))
  window.location.href = url
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background:
    linear-gradient(180deg, rgba(18, 22, 40, 0.78) 0%, rgba(9, 12, 28, 0.92) 100%),
    radial-gradient(900px 300px at 50% 120%, rgba(146, 84, 255, 0.18), transparent 60%);
  background-color: rgba(10, 13, 31, 0.88);
  border-top: 1px solid rgba(146, 84, 255, 0.28);
  box-shadow:
    0 -12px 32px rgba(146, 84, 255, 0.15),
    0 0 0 1px rgba(0, 224, 255, 0.06) inset;
  backdrop-filter: blur(14px) saturate(1.1);
  -webkit-backdrop-filter: blur(14px) saturate(1.1);
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding: 10px 0 8px;
  padding-bottom: 6px;
  z-index: 1000;
  color: #ffffff;
}
/* 安全区填充块（避免 iOS 底部半弧露底色露白） */
.bottom-nav::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: env(safe-area-inset-bottom, 0px);
  background:
    linear-gradient(180deg, rgba(9, 12, 28, 0.92) 0%, rgba(9, 12, 28, 1) 100%),
    radial-gradient(900px 300px at 50% 120%, rgba(146, 84, 255, 0.20), transparent 60%);
  pointer-events: none;
  z-index: 0;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 16px;
  transition: all 0.3s ease;
  position: relative;
  flex: 1;
  max-width: 20%;
  z-index: 1;
}
.nav-item:hover {
  background: rgba(146, 84, 255, 0.10);
}

.nav-item.center-item {
  margin-top: -24px;
  flex: 0 0 auto;
  max-width: none;
  z-index: 2;
}

.nav-item.center-item .nav-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #4096ff 0%, #9254ff 60%, #ff79c6 100%);
  border-radius: 50%;
  font-size: 28px;
  color: #ffffff;
  box-shadow:
    0 10px 28px rgba(146, 84, 255, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.12) inset,
    0 0 22px rgba(0, 224, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  filter: drop-shadow(0 3px 8px rgba(146,84,255,.30));
}

.nav-item.center-item:hover .nav-icon {
  transform: scale(1.1);
  box-shadow:
    0 14px 32px rgba(0, 224, 255, 0.38),
    0 0 0 1px rgba(255, 255, 255, 0.16) inset,
    0 0 28px rgba(146, 84, 255, 0.45);
}

.nav-item.center-item.active .nav-icon {
  transform: scale(1.05);
  box-shadow:
    0 12px 30px rgba(146, 84, 255, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.18) inset,
    0 0 32px rgba(0, 224, 255, 0.45);
}

.nav-icon {
  position: relative;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  transition: all 0.3s ease;
  color: #c9cde8;
}

.nav-item:not(.center-item) .nav-icon {
  color: #9aa3c9;
}

.nav-item.active:not(.center-item) .nav-icon {
  color: #00e0ff;
  filter:
    drop-shadow(0 0 2px rgba(0, 224, 255, 0.85))
    drop-shadow(0 2px 6px rgba(146, 84, 255, 0.55))
    drop-shadow(0 0 10px rgba(255, 121, 198, 0.35));
  transform: scale(1.1);
}

.nav-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: linear-gradient(135deg, #ff79c6 0%, #9254ff 100%);
  color: #ffffff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: 2px solid rgba(10, 13, 31, 0.9);
  box-shadow: 0 4px 12px rgba(255, 121, 198, 0.45), 0 0 0 1px rgba(146,84,255,0.30) inset;
  z-index: 10;
}

.nav-item.center-item .nav-badge {
  top: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  font-size: 12px;
}

.nav-text {
  font-size: 12px;
  font-weight: 500;
  color: #9aa3c9;
  transition: all 0.3s ease;
}

.nav-item.active:not(.center-item) .nav-text {
  font-weight: 700;
  background: linear-gradient(90deg, #00e0ff 0%, #9254ff 55%, #ff79c6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  filter: drop-shadow(0 2px 6px rgba(146,84,255,.30));
}

.nav-item.center-item .nav-text {
  margin-top: 4px;
  color: #ffffff;
  font-weight: 600;
  text-shadow: 0 2px 8px rgba(146,84,255,.35);
}

/* 激活项高亮背景 */
.nav-item.active:not(.center-item) {
  background: rgba(146, 84, 255, 0.14);
  box-shadow: 0 0 0 1px rgba(0, 224, 255, 0.22) inset;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .bottom-nav {
    padding: 8px 0 6px;
    padding-bottom: 6px;
  }

  .nav-item {
    padding: 6px 8px;
  }

  .nav-item.center-item {
    margin-top: -20px;
  }

  .nav-item.center-item .nav-icon {
    width: 48px;
    height: 48px;
    font-size: 24px;
  }

  .nav-icon {
    font-size: 20px;
    width: 24px;
    height: 24px;
  }

  .nav-text {
    font-size: 11px;
  }

  .nav-badge {
    width: 18px;
    height: 18px;
    font-size: 10px;
  }
}

/* 安全区域适配（iPhone X 等有刘海屏的设备） */
@supports (padding: max(0px)) {
  .bottom-nav {
    padding-bottom: 6px;
  }
}

/* 动画效果 */
.nav-item {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 为每个导航项添加不同的延迟动画 */
.nav-item:nth-child(1) { animation-delay: 0.1s; }
.nav-item:nth-child(2) { animation-delay: 0.2s; }
.nav-item:nth-child(3) { animation-delay: 0.3s; }
.nav-item:nth-child(4) { animation-delay: 0.4s; }
.nav-item:nth-child(5) { animation-delay: 0.5s; }
</style>
